export enum OrderDocumentType {
  PURCHASE_ORDER = "PURCHASE_ORDER",
  SALES_ORDER = "SALES_ORDER",
  INVOICE = "INVOICE",
  PAYMENT = "PAYMENT",
  RECEIPT = "RECEIPT"
}
